import React from "react";
import Icon from "../atoms/Icon";
import InputGroup from "../atoms/InputGroup";
// import  from ''
const DynamicForm = ({
  title,
  onchangeInput,
  number,
  onDeleteForm,
  quality,
  data,
}) => {
  const handleDeleteForm = () => {
    onDeleteForm(number); // Call the onDeleteForm callback with the form's index
  };
  // console.log(data.id > 0);
  // const quality=true
  if (data.id) {
    // console.log("dynamic form data");
    return (
      <>
        <div className="flex flex-row items-baseline pt-7.5px">
          <p className="whitespace-nowrap pl-2.5 text-grayT text-14">{`اطلاعات سنسور ${number}`}</p>
          <div className="w-full border-t-2 border-grayT"></div>
          <div className="flex flex-row gap-1">
            <Icon iconName={"trashR"} />
            <button
              className="whitespace-nowrap pl-2.5 text-red text-14"
              onClick={handleDeleteForm}>
              حذف سنسور
            </button>
          </div>
        </div>
        <div className="flex flex-row justify-between w- gap-5 mt-25">
          <InputGroup
            placeholder=" مانند CO2-MW"
            label={"نام نمایشی سنسور (نمایش برای کاربر)"}
            val={data.username}
            icon={false}
            onchange={onchangeInput}
            name={"username"}
            onchangeAble={true}
          />
          <InputGroup
            placeholder=" مانند CO2-MW"
            label={"نام قراردادی (استفاده در JSON)"}
            val={data.jsonname}
            icon={false}
            onchange={onchangeInput}
            name={"jsonname"}
            onchangeAble={true}
          />
          <InputGroup
            placeholder=" مانند CO2-MW"
            label={"واحد اندازه گیری"}
            val={data.measurunit}
            icon={false}
            onchange={onchangeInput}
            name={"measurunit"}
            onchangeAble={true}
          />
        </div>
        <div className="flex flex-row justify-between w- gap-5 mt-25 ">
          <InputGroup
            placeholder=" مانند 55 "
            label={"بیشترین مقدار"}
            val={data.maxamount}
            icon={false}
            onchange={onchangeInput}
            name={"maxamount"}
            onchangeAble={true}
            direction={"ltr"}
            AddClass={"text-end"}
          />
          <InputGroup
            placeholder=" مانند 5 "
            label={"کمترین مقدار"}
            val={data.minamount}
            icon={false}
            onchange={onchangeInput}
            name={"minamount"}
            onchangeAble={true}
            direction={"ltr"}
            AddClass={"text-end"}
          />

          {quality ? null : (
            <>
              <InputGroup
                placeholder=" مانند 100 "
                label={"بیشترین شاخص"}
                val={data.maxIndex}
                icon={false}
                onchange={onchangeInput}
                name={"maxIndex"}
                onchangeAble={true}
                direction={"ltr"}
                AddClass={"text-end"}
              />
              <InputGroup
                placeholder=" مانند 0 "
                label={"کمترین شاخص"}
                val={data.minIndex}
                icon={false}
                onchange={onchangeInput}
                name={"minIndex"}
                onchangeAble={true}
                direction={"ltr"}
                AddClass={"text-end"}
              />
            </>
          )}
        </div>
      </>
    );
  } else {
    // console.log("dynamic form not data");
    return (
      <>
        <div className="flex flex-row items-baseline pt-7.5px">
          <p className="whitespace-nowrap pl-2.5 text-grayT text-14">{`اطلاعات سنسور ${number}`}</p>
          <div className="w-full border-t-2 border-grayT"></div>
          <div className="flex flex-row gap-1">
            <Icon iconName={"trashR"} />
            <button
              className="whitespace-nowrap pl-2.5 text-red text-14"
              onClick={handleDeleteForm}>
              حذف سنسور
            </button>
          </div>
        </div>
        <div className="flex flex-row justify-between w- gap-5 mt-25">
          <InputGroup
            icon={false}
            label={"نام نمایشی سنسور (نمایش برای کاربر)"}
            name={"username"}
            onchange={onchangeInput}
            placeholder=" مانند دما "
            onchangeAble={true}
          />
          <InputGroup
            icon={false}
            label={"نام قراردادی (استفاده در JSON)"}
            name={"jsonname"}
            onchange={onchangeInput}
            placeholder=" مانندTEMP"
            onchangeAble={true}
          />
          <InputGroup
            icon={false}
            label={"واحد اندازه گیری"}
            name={"measurunit"}
            onchange={onchangeInput}
            placeholder=" مانند%"
            onchangeAble={true}
          />
        </div>
        <div className="flex flex-row justify-between w- gap-5 mt-25">
          <InputGroup
            icon={false}
            label={"بیشترین مقدار"}
            name={"maxamount"}
            onchange={onchangeInput}
            placeholder=" مانند 55"
            onchangeAble={true}
            direction={"ltr"}
            AddClass={"text-end"}
          />
          <InputGroup
            icon={false}
            label={"کمترین مقدار"}
            name={"minamount"}
            onchange={onchangeInput}
            placeholder=" مانند-16"
            onchangeAble={true}
            direction={"ltr"}
            AddClass={"text-end"}
          />

          {quality ? null : (
            <>
              <InputGroup
                icon={false}
                label={"بیشترین شاخص"}
                name={"maxIndex"}
                onchange={onchangeInput}
                placeholder=" مانند 10 "
                onchangeAble={true}
                direction={"ltr"}
                AddClass={"text-end"}
              />
              <InputGroup
                icon={false}
                label={"کمترین شاخص"}
                name={"minIndex"}
                onchange={onchangeInput}
                placeholder=" مانند 0"
                onchangeAble={true}
                direction={"ltr"}
                AddClass={"text-end"}
              />
            </>
          )}
        </div>
      </>
    );
  }
  // return (
  //   <>
  //     <div className="flex flex-row items-baseline pt-7.5px">
  //       <p className="whitespace-nowrap pl-2.5 text-grayT text-14">{`اطلاعات سنسور ${number}`}</p>
  //       <div className="w-full border-t-2 border-grayT"></div>
  //       <div className="flex flex-row gap-1">
  //         <Icon iconName={"trashR"} />
  //         <button
  //           className="whitespace-nowrap pl-2.5 text-red text-14"
  //           onClick={handleDeleteForm}>
  //           حذف سنسور
  //         </button>
  //       </div>
  //     </div>
  //     <div className="flex flex-row justify-between w- gap-5 mt-25">
  //       <InputGroup
  //         icon={false}
  //         label={"نام نمایشی سنسور (نمایش برای کاربر)"}
  //         name={"username"}
  //         onchange={onchangeInput}
  //         placeholder=" مانند دما "
  //         onchangeAble={true}
  //       />
  //       <InputGroup
  //         icon={false}
  //         label={"نام قراردادی (استفاده در JSON)"}
  //         name={"jsonname"}
  //         onchange={onchangeInput}
  //         placeholder=" مانندTEMP"
  //         onchangeAble={true}
  //       />
  //       <InputGroup
  //         icon={false}
  //         label={"واحد اندازه گیری"}
  //         name={"mesureType"}
  //         onchange={onchangeInput}
  //         placeholder=" مانند%"
  //         onchangeAble={true}
  //       />
  //     </div>
  //     <div className="flex flex-row justify-between w- gap-5 mt-25">
  //       <InputGroup
  //         icon={false}
  //         label={"بیشترین شاخص"}
  //         name={"maxindex"}
  //         onchange={onchangeInput}
  //         placeholder=" مانند دما "
  //         onchangeAble={true}
  //       />
  //       <InputGroup
  //         icon={false}
  //         label={"کمترین شاخص"}
  //         name={"minindex"}
  //         onchange={onchangeInput}
  //         placeholder=" مانندTEMP"
  //         onchangeAble={true}
  //       />
  //       {quality ? null : (
  //         <>
  //           <InputGroup
  //             icon={false}
  //             label={"بیشترین مقدار"}
  //             name={"maxamount"}
  //             onchange={onchangeInput}
  //             placeholder=" مانند 55"
  //             onchangeAble={true}
  //           />
  //           <InputGroup
  //             icon={false}
  //             label={"کمترین مقدار"}
  //             name={"minamount"}
  //             onchange={onchangeInput}
  //             placeholder=" مانند-16"
  //             onchangeAble={true}
  //           />
  //         </>
  //       )}
  //     </div>
  //   </>
  // );
};

export default DynamicForm;
